import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register({ email, password, passwordConfirm, name });
      navigate('/mon-compte', { replace: true });
    } catch (err) {
      setError(err?.message || "Inscription impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section">
      <div className="section-inner" style={{ maxWidth: 520 }}>
        <div className="section-header">
          <h2>Créer un compte</h2>
          <p>Rejoignez la plateforme pour accéder à votre espace.</p>
        </div>
        <form onSubmit={onSubmit} className="card">
          <div className="form-group">
            <label htmlFor="name">Nom</label>
            <input id="name" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="passwordConfirm">Confirmer le mot de passe</label>
            <input id="passwordConfirm" type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} required />
          </div>
          {error ? <p style={{ color: '#ef4444', marginTop: 8 }}>{error}</p> : null}
          <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Création…' : 'Créer le compte'}
            </button>
            <Link className="btn btn-ghost" to="/login">J'ai déjà un compte</Link>
          </div>
        </form>
      </div>
    </section>
  );
}
